const fr = {
  app: { name: "MediFlow Africa", tagline: "Gestion de clinique nouvelle génération" },
  common: {
    save: "Enregistrer",
    cancel: "Annuler",
    delete: "Supprimer",
    edit: "Modifier",
    create: "Créer",
    add: "Ajouter",
    search: "Rechercher",
    loading: "Chargement…",
    actions: "Actions",
    status: "Statut",
    date: "Date",
    time: "Heure",
    amount: "Montant",
    total: "Total",
    name: "Nom",
    email: "E-mail",
    phone: "Téléphone",
    submit: "Valider",
    close: "Fermer",
    confirm: "Confirmer",
    back: "Retour",
    yes: "Oui",
    no: "Non",
    all: "Tous",
    export: "Exporter",
    print: "Imprimer",
    new: "Nouveau",
    today: "Aujourd'hui",
    week: "Semaine",
    day: "Jour",
    view: "Voir",
    details: "Détails",
    noData: "Aucune donnée",
    required: "Champ requis",
    success: "Succès",
    error: "Erreur",
    xof: "FCFA",
  },
  nav: {
    dashboard: "Tableau de bord",
    insights: "Pilotage",
    patients: "Patients",
    appointments: "Rendez-vous",
    consultations: "Consultations",
    invoices: "Factures",
    payments: "Paiements",
    cash: "Caisse",
    stock: "Stock",
    users: "Utilisateurs",
    reports: "Rapports",
    documentation: "Documentation",
    billing: "Abonnement",
    logout: "Déconnexion",
    settings: "Paramètres",
  },
  roles: {
    owner: "Propriétaire",
    admin: "Administrateur",
    doctor: "Médecin",
    nurse: "Infirmier(e)",
    secretary: "Secrétaire",
    cashier: "Caissier(e)",
    stock_manager: "Gestionnaire de stock",
  },
  specialties: {
    general: "Médecine générale",
    dentist: "Dentiste",
    pediatrician: "Pédiatre",
    psychologist: "Psychologue",
    gynecologist: "Gynécologue",
  },
  auth: {
    loginTitle: "Connexion",
    loginSubtitle: "Accédez à votre clinique",
    email: "E-mail",
    password: "Mot de passe",
    signIn: "Se connecter",
    registerClinic: "Créer ma clinique",
    createClinic: "Enregistrer une clinique",
    clinicName: "Nom de la clinique",
    ownerFirstName: "Prénom du responsable",
    ownerLastName: "Nom du responsable",
    country: "Pays",
    currency: "Devise",
    noAccount: "Pas encore de clinique ?",
    hasAccount: "J'ai déjà un compte",
    forgotPassword: "Mot de passe oublié ?",
    mustChangeTitle: "Changement de mot de passe requis",
    mustChangeSubtitle: "Pour votre sécurité, veuillez définir un nouveau mot de passe.",
    currentPassword: "Mot de passe actuel",
    newPassword: "Nouveau mot de passe",
    reset: "Réinitialiser",
    tempPasswordNote: "Mot de passe temporaire émis.",
    loginError: "Identifiants invalides",
  },
  dashboard: {
    title: "Tableau de bord",
    patientsToday: "Patients du jour",
    appointmentsToday: "RDV du jour",
    revenueToday: "Revenus du jour",
    unpaid: "Factures impayées",
    stockAlerts: "Alertes stock",
    topMeds: "Médicaments les plus utilisés",
    totalPatients: "Total patients",
    lowStock: "Stock bas",
    outOfStock: "Rupture",
    welcome: "Bienvenue",
  },
  patients: {
    title: "Patients",
    new: "Nouveau patient",
    firstName: "Prénom",
    lastName: "Nom",
    dob: "Date de naissance",
    gender: "Genre",
    address: "Adresse",
    emergency: "Contact d'urgence",
    bloodGroup: "Groupe sanguin",
    allergies: "Allergies",
    insurance: "Assurance",
    history: "Historique",
    searchPh: "Rechercher par nom, téléphone ou ID…",
    male: "Masculin",
    female: "Féminin",
    other: "Autre",
    statusNew: "Nouveau",
    statusActive: "Actif",
    statusFollowUp: "Suivi requis",
    filterAll: "Tous",
    filterActive: "Actifs",
    filterNew: "Nouveaux",
    filterFollowUp: "Suivi requis",
    visits: "consultation",
    visits_plural: "consultations",
    lastVisit: "Dernière visite",
    neverVisited: "Jamais consulté",
    unpaidInvoices: "facture(s) impayée(s)",
    actView: "Voir",
    actAppointment: "RDV",
    actConsult: "Consulter",
    actInvoice: "Facture",
    countShown: "{n} patient(s)",
  },
  appointments: {
    title: "Rendez-vous",
    new: "Nouveau RDV",
    patient: "Patient",
    doctor: "Praticien",
    start: "Début",
    end: "Fin",
    reason: "Motif",
    queue: "File d'attente",
    markArrived: "Marquer comme arrivé",
    startConsult: "Démarrer consultation",
    complete: "Terminer",
    cancel: "Annuler",
    noShow: "Absent",
    waiting: "Patients en attente",
    noWaiting: "Aucun patient en attente",
    waitingTime: "attente",
    delayLate: "Retard",
    delayOk: "À l'heure",
    metricsTotal: "RDV du jour",
    metricsCompleted: "Terminés",
    metricsWaiting: "En attente",
    metricsNoShow: "Absents",
    metricsInProgress: "En cours",
    status: {
      scheduled: "Planifié",
      confirmed: "Confirmé",
      arrived: "Arrivé",
      in_consultation: "En consultation",
      completed: "Terminé",
      cancelled: "Annulé",
      no_show: "Absent",
    },
  },
  consultations: {
    title: "Consultations",
    new: "Nouvelle consultation",
    reason: "Motif",
    observations: "Observations cliniques",
    treatment: "Traitement",
    vitals: "Signes vitaux",
    weight: "Poids (kg)",
    temperature: "Température (°C)",
    bp: "Tension artérielle",
    heartRate: "Fréquence cardiaque",
    notes: "Notes cliniques",
    diagnosis: "Diagnostic",
    prescription: "Prescription",
    addMed: "Ajouter un médicament",
    medName: "Médicament",
    dosage: "Dosage",
    frequency: "Fréquence",
    duration: "Durée",
    quantity: "Quantité",
    save: "Enregistrer la consultation",
    stockLinked: "Stock mis à jour",
    detail: "Détail de la consultation",
    actView: "Voir",
    actEdit: "Modifier",
    actInvoice: "Facturer",
    actPdf: "PDF",
    filterAll: "Tous",
    filterCompleted: "Terminées",
    filterInvoiced: "Facturées",
    filterPatient: "Patient",
    filterDoctor: "Praticien",
    filterFrom: "Du",
    filterTo: "Au",
    clearFilters: "Réinitialiser",
    statusCompleted: "Terminée",
    statusInvoiced: "Facturée",
    noReason: "Aucun motif renseigné",
    hasInvoice: "Facture",
    viewInvoice: "Voir facture",
  },
  invoices: {
    title: "Factures",
    new: "Nouvelle facture",
    number: "Numéro",
    items: "Articles",
    itemName: "Description",
    itemType: "Type",
    qty: "Qté",
    unitPrice: "Prix unitaire",
    subtotal: "Sous-total",
    discount: "Remise",
    balance: "Reste à payer",
    addItem: "Ajouter une ligne",
    service: "Service",
    medication: "Médicament",
    other: "Autre",
    status: { unpaid: "Impayée", partial: "Partielle", paid: "Payée" },
    payNow: "Encaisser",
    type: "Type",
    typeConsultation: "Consultation",
    typeConsultationMeds: "Consultation + médicaments",
    typeMedsOnly: "Médicaments",
    typeOther: "Autre",
    summaryInvoicedToday: "Facturé aujourd'hui",
    summaryCollectedToday: "Encaissé aujourd'hui",
    summaryUnpaid: "Total impayé",
    overdueWarning: "Impayé depuis {n} jour(s)",
    filterAll: "Toutes",
    filterPaid: "Payées",
    filterUnpaid: "Impayées",
    filterPartial: "Partielles",
    filterOverdue: "En retard",
    detail: "Détail de la facture",
    linkedConsultation: "Consultation liée",
    paymentsHistory: "Historique des paiements",
    actView: "Voir",
    actPay: "Encaisser",
    actPdf: "PDF",
    actEdit: "Modifier",
    cannotEditPaid: "Impossible de modifier une facture avec paiements",
    noItems: "Aucun article",
  },
  payments: {
    title: "Paiements",
    new: "Nouveau paiement",
    method: "Méthode",
    cash: "Espèces",
    card: "Carte",
    wave: "Wave",
    orange_money: "Orange Money",
    reference: "Référence",
    amount: "Montant",
    summaryTotalToday: "Total encaissé aujourd'hui",
    summaryByMethod: "Ventilation par méthode",
    filterAll: "Toutes",
    filterMethod: "Méthode",
    filterUser: "Encaissé par",
    filterDateFrom: "Du",
    filterDateTo: "Au",
    clearFilters: "Réinitialiser",
    statusFull: "Complet",
    statusPartial: "Partiel",
    cashier: "Encaissé par",
    invoice: "Facture",
    patient: "Patient",
    detail: "Détail du paiement",
    exportXlsx: "Exporter Excel",
    exportPdf: "Exporter PDF",
    count: "{n} paiement(s)",
    noInvoice: "—",
    simulated: "Simulé",
  },
  cash: {
    title: "Caisse",
    open: "Ouvrir la caisse",
    close: "Clôturer la caisse",
    opening: "Fonds d'ouverture",
    closing: "Fonds de clôture",
    expected: "Attendu en caisse",
    variance: "Écart",
    cashIn: "Espèces encaissées",
    history: "Historique des sessions",
    currentSession: "Session en cours",
    noSession: "Aucune session ouverte",
    openedBy: "Ouverte par",
    closedBy: "Fermée par",
    openedAt: "Ouverte le",
    closedAt: "Fermée le",
    duration: "Durée",
    totalCollected: "Total encaissé",
    byMethod: "Ventilation par méthode",
    transactions: "Transactions de la session",
    noTransactions: "Aucune transaction depuis l'ouverture",
    statusOpen: "Ouverte",
    statusClosed: "Fermée",
    actualCounted: "Montant réellement compté",
    countedHint: "Saisissez le montant réel compté dans la caisse",
    confirmClose: "Confirmer la clôture",
    varianceOk: "Caisse équilibrée",
    varianceOver: "Excédent de caisse",
    varianceShort: "Manque de caisse",
    exportCsv: "Exporter",
    session: "Session",
    cashExpected: "Espèces attendues",
  },
  stock: {
    title: "Stock médical",
    products: "Produits",
    lots: "Lots",
    movements: "Mouvements",
    alerts: "Alertes",
    newProduct: "Nouveau produit",
    newLot: "Nouveau lot",
    newMovement: "Nouveau mouvement",
    productName: "Nom du produit",
    category: "Catégorie",
    unit: "Unité",
    purchasePrice: "Prix d'achat",
    salePrice: "Prix de vente",
    minThreshold: "Seuil minimum",
    stockQty: "Stock",
    batchNumber: "N° de lot",
    expDate: "Péremption",
    supplier: "Fournisseur",
    type: "Type",
    subtype: "Sous-type",
    quantity: "Quantité",
    reason: "Raison",
    lowStock: "Stock bas",
    outOfStock: "Rupture",
    expiringSoon: "Péremption proche (30j)",
    expired: "Périmés",
    in: "Entrée",
    out: "Sortie",
    purchase: "Achat",
    donation: "Don",
    consumption: "Consommation patient",
    internal: "Usage interne",
    loss: "Perte",
    adjustment: "Ajustement",
    barcode: "Code-barres",
    scan: "Scanner",
    scanHint: "Présentez le code-barres devant la caméra",
    scanPermission: "Autorisez l'accès à la caméra pour scanner",
    scanNotFound: "Produit non trouvé — créer ?",
    quickEntry: "Ajout rapide au stock",
    quickEntryHint: "Scanner ou sélectionner un produit puis entrer la quantité",
    quickAdd: "Ajouter au stock",
    importExcel: "Importer Excel / CSV",
    importHint: "Colonnes requises : Nom (obligatoire) + optionnelles : Catégorie, Unité, Prix d'achat, Prix de vente, Seuil minimum, Code-barres, Stock. Les en-têtes en français et en anglais sont détectés automatiquement.",
    importTemplate: "Modèle à télécharger",
    imported: "{created} créés · {updated} mis à jour",
    importErrors: "Erreurs :",
    selectFile: "Choisir un fichier",
    totalProducts: "Produits en catalogue",
    predictedDepletion: "Rupture prévisionnelle",
    predictedHint: "Jours restants estimés au rythme actuel",
    daysLeft: "{n}j",
    criticalSoon: "Épuisement proche",
    noCriticalSoon: "Aucun risque d'épuisement détecté",
    consumedBy: "Consommé par",
    recordedBy: "Enregistré par",
    fifoNote: "FIFO : le lot le plus proche de la péremption est sorti en premier",
  },
  users: {
    title: "Utilisateurs",
    new: "Nouvel utilisateur",
    edit: "Modifier l'utilisateur",
    role: "Rôle",
    specialty: "Spécialité",
    active: "Actif",
    resetPassword: "Réinitialiser mdp",
    tempPassword: "Mot de passe temporaire",
    deactivate: "Désactiver",
    activate: "Activer",
    initialPassword: "Mot de passe initial (optionnel)",
    permissions: "Permissions",
    permissionsHint: "Cochez les modules et actions autorisés pour cet utilisateur.",
    adminLevel: "Niveau admin",
    main: "Principal",
    secondary: "Secondaire",
    adminMain: "Admin principal",
    adminSecondary: "Admin secondaire",
    delegation: "Délégation temporaire",
    delegationHint: "Accorder des permissions supplémentaires sur une période donnée",
    delegationFrom: "Du",
    delegationUntil: "Au",
    delegatedPerms: "Permissions déléguées",
    selectAll: "Tout cocher",
    deselectAll: "Tout décocher",
    resetToRole: "Permissions par défaut du rôle",
    nPermissions: "{n} permission(s)",
    modules: {
      patients: "Patients", appointments: "Rendez-vous", consultations: "Consultations",
      invoices: "Factures", payments: "Paiements", cash: "Caisse",
      stock: "Stock", users: "Utilisateurs", reports: "Rapports", settings: "Paramètres",
    },
    actions: {
      view: "Voir", create: "Créer", edit: "Modifier", delete: "Supprimer",
      validate: "Valider", export: "Exporter",
      manage_permissions: "Gérer permissions", manage_admins: "Créer admins",
    },
  },
  reports: {
    title: "Rapports",
    kind: "Type",
    from: "Du",
    to: "Au",
    download: "Télécharger",
    xlsx: "Excel",
    pdf: "PDF",
    kinds: {
      patients: "Patients",
      appointments: "Rendez-vous",
      consultations: "Consultations",
      invoices: "Factures",
      payments: "Paiements",
      stock_movements: "Mouvements de stock",
      expired: "Produits périmés",
    },
  },
  billing: {
    title: "Abonnement",
    nav: "Abonnement",
    currentPlan: "Plan actuel",
    status: "Statut",
    daysRemaining: "Jours restants",
    renewBy: "À renouveler avant",
    statuses: {
      trial: "Essai gratuit",
      active: "Actif",
      grace: "Période de grâce",
      read_only: "Lecture seule",
      cancelled: "Annulé",
    },
    chooseYourPlan: "Choisissez votre plan",
    perMonth: "/ mois",
    subscribeCard: "Payer par carte (Stripe)",
    subscribeWave: "Payer via Wave",
    subscribeOrange: "Payer via Orange Money",
    mostPopular: "Plus populaire",
    cancel: "Annuler l'abonnement",
    transactions: "Historique des paiements",
    bannerTrial: "Vous êtes en essai gratuit",
    bannerGrace: "Période de grâce — paiement requis sous peu",
    bannerReadOnly: "Abonnement expiré — lecture seule",
    bannerCancelled: "Abonnement annulé",
    renew: "Renouveler maintenant",
    paymentProcessing: "Paiement en cours de validation…",
    paymentSuccess: "Paiement confirmé !",
    paymentFailed: "Le paiement a échoué ou a été annulé.",
    currentlyOn: "Plan actuel",
    upgrade: "Passer au plan",
    simulatedNote: "Paiement mobile money simulé — la vraie intégration sera activée en production.",
  },
};

const en = {
  app: { name: "MediFlow Africa", tagline: "Next-gen clinic management" },
  common: {
    save: "Save", cancel: "Cancel", delete: "Delete", edit: "Edit", create: "Create",
    add: "Add", search: "Search", loading: "Loading…", actions: "Actions", status: "Status",
    date: "Date", time: "Time", amount: "Amount", total: "Total", name: "Name",
    email: "Email", phone: "Phone", submit: "Submit", close: "Close", confirm: "Confirm",
    back: "Back", yes: "Yes", no: "No", all: "All", export: "Export", print: "Print",
    new: "New", today: "Today", week: "Week", day: "Day", view: "View", details: "Details",
    noData: "No data", required: "Required", success: "Success", error: "Error", xof: "XOF",
  },
  nav: {
    dashboard: "Dashboard", insights: "Insights", patients: "Patients", appointments: "Appointments",
    consultations: "Consultations", invoices: "Invoices", payments: "Payments",
    cash: "Cash Register", stock: "Stock", users: "Users", reports: "Reports",
    documentation: "Documentation",
    billing: "Subscription",
    logout: "Sign out", settings: "Settings",
  },
  roles: {
    owner: "Owner", admin: "Admin", doctor: "Doctor", nurse: "Nurse", secretary: "Secretary",
    cashier: "Cashier", stock_manager: "Stock Manager",
  },
  specialties: {
    general: "General practice", dentist: "Dentist", pediatrician: "Pediatrician",
    psychologist: "Psychologist", gynecologist: "Gynecologist",
  },
  auth: {
    loginTitle: "Sign in", loginSubtitle: "Access your clinic",
    email: "Email", password: "Password", signIn: "Sign in",
    registerClinic: "Create my clinic", createClinic: "Register a clinic",
    clinicName: "Clinic name", ownerFirstName: "Owner first name",
    ownerLastName: "Owner last name", country: "Country", currency: "Currency",
    noAccount: "No clinic yet?", hasAccount: "I already have an account",
    forgotPassword: "Forgot password?",
    mustChangeTitle: "Password change required",
    mustChangeSubtitle: "For your security, please set a new password.",
    currentPassword: "Current password", newPassword: "New password",
    reset: "Reset", tempPasswordNote: "Temporary password issued.",
    loginError: "Invalid credentials",
  },
  dashboard: {
    title: "Dashboard", patientsToday: "Patients today", appointmentsToday: "Appointments today",
    revenueToday: "Revenue today", unpaid: "Unpaid invoices", stockAlerts: "Stock alerts",
    topMeds: "Most used medications", totalPatients: "Total patients",
    lowStock: "Low stock", outOfStock: "Out of stock", welcome: "Welcome",
  },
  patients: {
    title: "Patients", new: "New patient", firstName: "First name", lastName: "Last name",
    dob: "Date of birth", gender: "Gender", address: "Address", emergency: "Emergency contact",
    bloodGroup: "Blood group", allergies: "Allergies", insurance: "Insurance",
    history: "History", searchPh: "Search by name, phone or ID…",
    male: "Male", female: "Female", other: "Other",
    statusNew: "New", statusActive: "Active", statusFollowUp: "Follow-up",
    filterAll: "All", filterActive: "Active", filterNew: "New", filterFollowUp: "Follow-up",
    visits: "visit", visits_plural: "visits",
    lastVisit: "Last visit", neverVisited: "Never visited",
    unpaidInvoices: "unpaid invoice(s)",
    actView: "View", actAppointment: "Appt", actConsult: "Consult", actInvoice: "Invoice",
    countShown: "{n} patient(s)",
  },
  appointments: {
    title: "Appointments", new: "New appointment", patient: "Patient", doctor: "Practitioner",
    start: "Start", end: "End", reason: "Reason", queue: "Queue",
    markArrived: "Mark as arrived", startConsult: "Start consultation",
    complete: "Complete", cancel: "Cancel", noShow: "No-show",
    waiting: "Waiting patients", noWaiting: "No patients waiting",
    waitingTime: "waiting", delayLate: "Late", delayOk: "On time",
    metricsTotal: "Today's appts", metricsCompleted: "Completed", metricsWaiting: "Waiting",
    metricsNoShow: "No-shows", metricsInProgress: "In progress",
    status: { scheduled: "Scheduled", confirmed: "Confirmed", arrived: "Arrived",
      in_consultation: "In consultation", completed: "Completed", cancelled: "Cancelled", no_show: "No show" },
  },
  consultations: {
    title: "Consultations", new: "New consultation",
    reason: "Reason", observations: "Clinical observations", treatment: "Treatment",
    vitals: "Vital signs", weight: "Weight (kg)", temperature: "Temperature (°C)",
    bp: "Blood pressure", heartRate: "Heart rate",
    notes: "Clinical notes", diagnosis: "Diagnosis", prescription: "Prescription",
    addMed: "Add medication", medName: "Medication", dosage: "Dosage",
    frequency: "Frequency", duration: "Duration", quantity: "Quantity",
    save: "Save consultation", stockLinked: "Stock updated",
    detail: "Consultation detail",
    actView: "View", actEdit: "Edit", actInvoice: "Invoice", actPdf: "PDF",
    filterAll: "All", filterCompleted: "Completed", filterInvoiced: "Invoiced",
    filterPatient: "Patient", filterDoctor: "Practitioner",
    filterFrom: "From", filterTo: "To", clearFilters: "Reset",
    statusCompleted: "Completed", statusInvoiced: "Invoiced",
    noReason: "No reason given", hasInvoice: "Invoice", viewInvoice: "View invoice",
  },
  invoices: {
    title: "Invoices", new: "New invoice", number: "Number", items: "Items",
    itemName: "Description", itemType: "Type", qty: "Qty", unitPrice: "Unit price",
    subtotal: "Subtotal", discount: "Discount", balance: "Balance", addItem: "Add line",
    service: "Service", medication: "Medication", other: "Other",
    status: { unpaid: "Unpaid", partial: "Partial", paid: "Paid" }, payNow: "Collect",
    type: "Type", typeConsultation: "Consultation", typeConsultationMeds: "Consultation + meds",
    typeMedsOnly: "Medications", typeOther: "Other",
    summaryInvoicedToday: "Invoiced today", summaryCollectedToday: "Collected today",
    summaryUnpaid: "Total unpaid",
    overdueWarning: "Unpaid for {n} day(s)",
    filterAll: "All", filterPaid: "Paid", filterUnpaid: "Unpaid",
    filterPartial: "Partial", filterOverdue: "Overdue",
    detail: "Invoice detail", linkedConsultation: "Linked consultation",
    paymentsHistory: "Payment history",
    actView: "View", actPay: "Collect", actPdf: "PDF", actEdit: "Edit",
    cannotEditPaid: "Cannot edit an invoice with payments",
    noItems: "No items",
  },
  payments: {
    title: "Payments", new: "New payment", method: "Method", cash: "Cash", card: "Card",
    wave: "Wave", orange_money: "Orange Money", reference: "Reference", amount: "Amount",
    summaryTotalToday: "Total collected today",
    summaryByMethod: "Breakdown by method",
    filterAll: "All", filterMethod: "Method", filterUser: "Collected by",
    filterDateFrom: "From", filterDateTo: "To", clearFilters: "Reset",
    statusFull: "Full", statusPartial: "Partial",
    cashier: "Collected by", invoice: "Invoice", patient: "Patient",
    detail: "Payment detail",
    exportXlsx: "Export Excel", exportPdf: "Export PDF",
    count: "{n} payment(s)", noInvoice: "—", simulated: "SIM",
  },
  cash: {
    title: "Cash Register", open: "Open register", close: "Close register",
    opening: "Opening balance", closing: "Closing balance", expected: "Expected in drawer",
    variance: "Variance", cashIn: "Cash received", history: "Register history",
    currentSession: "Current session", noSession: "No open session",
    openedBy: "Opened by", closedBy: "Closed by",
    openedAt: "Opened at", closedAt: "Closed at", duration: "Duration",
    totalCollected: "Total collected", byMethod: "Breakdown by method",
    transactions: "Session transactions", noTransactions: "No transactions since opening",
    statusOpen: "Open", statusClosed: "Closed",
    actualCounted: "Actual counted amount",
    countedHint: "Enter the amount physically counted in the drawer",
    confirmClose: "Confirm close",
    varianceOk: "Balanced",
    varianceOver: "Cash over",
    varianceShort: "Cash short",
    exportCsv: "Export",
    session: "Session",
    cashExpected: "Expected cash",
  },
  stock: {
    title: "Medical Stock", products: "Products", lots: "Lots", movements: "Movements",
    alerts: "Alerts", newProduct: "New product", newLot: "New lot", newMovement: "New movement",
    productName: "Product name", category: "Category", unit: "Unit",
    purchasePrice: "Purchase price", salePrice: "Sale price", minThreshold: "Min threshold",
    stockQty: "Stock", batchNumber: "Batch #", expDate: "Expiry", supplier: "Supplier",
    type: "Type", subtype: "Subtype", quantity: "Quantity", reason: "Reason",
    lowStock: "Low stock", outOfStock: "Out of stock",
    expiringSoon: "Expiring soon (30d)", expired: "Expired",
    in: "IN", out: "OUT", purchase: "Purchase", donation: "Donation",
    consumption: "Patient consumption", internal: "Internal use", loss: "Loss",
    adjustment: "Adjustment",
    barcode: "Barcode", scan: "Scan",
    scanHint: "Show the barcode in front of the camera",
    scanPermission: "Please allow camera access to scan",
    scanNotFound: "Product not found — create it?",
    quickEntry: "Quick stock entry",
    quickEntryHint: "Scan or select a product and enter quantity",
    quickAdd: "Add to stock",
    importExcel: "Import Excel / CSV",
    importHint: "Required: Name + optional: Category, Unit, Purchase price, Sale price, Minimum threshold, Barcode, Quantity. French and English headers are auto-detected.",
    importTemplate: "Download template",
    imported: "{created} created · {updated} updated",
    importErrors: "Errors:",
    selectFile: "Choose file",
    totalProducts: "Products in catalog",
    predictedDepletion: "Predicted depletion",
    predictedHint: "Estimated days left at current usage rate",
    daysLeft: "{n}d",
    criticalSoon: "Running out soon",
    noCriticalSoon: "No depletion risk detected",
    consumedBy: "Consumed by",
    recordedBy: "Recorded by",
    fifoNote: "FIFO: lot closest to expiry is used first",
  },
  users: {
    title: "Users", new: "New user", edit: "Edit user",
    role: "Role", specialty: "Specialty",
    active: "Active", resetPassword: "Reset password", tempPassword: "Temp password",
    deactivate: "Deactivate", activate: "Activate",
    initialPassword: "Initial password (optional)",
    permissions: "Permissions",
    permissionsHint: "Check modules and actions allowed for this user.",
    adminLevel: "Admin level", main: "Main", secondary: "Secondary",
    adminMain: "Main admin", adminSecondary: "Secondary admin",
    delegation: "Temporary delegation",
    delegationHint: "Grant extra permissions during a time period",
    delegationFrom: "From", delegationUntil: "Until",
    delegatedPerms: "Delegated permissions",
    selectAll: "Select all", deselectAll: "Deselect all",
    resetToRole: "Reset to role defaults",
    nPermissions: "{n} permission(s)",
    modules: {
      patients: "Patients", appointments: "Appointments", consultations: "Consultations",
      invoices: "Invoices", payments: "Payments", cash: "Cash",
      stock: "Stock", users: "Users", reports: "Reports", settings: "Settings",
    },
    actions: {
      view: "View", create: "Create", edit: "Edit", delete: "Delete",
      validate: "Validate", export: "Export",
      manage_permissions: "Manage permissions", manage_admins: "Create admins",
    },
  },
  reports: {
    title: "Reports", kind: "Type", from: "From", to: "To",
    download: "Download", xlsx: "Excel", pdf: "PDF",
    kinds: {
      patients: "Patients", appointments: "Appointments", consultations: "Consultations",
      invoices: "Invoices", payments: "Payments", stock_movements: "Stock movements",
      expired: "Expired products",
    },
  },
  billing: {
    title: "Subscription", nav: "Subscription",
    currentPlan: "Current plan", status: "Status", daysRemaining: "Days remaining",
    renewBy: "Renew by",
    statuses: { trial: "Free trial", active: "Active", grace: "Grace period", read_only: "Read-only", cancelled: "Cancelled" },
    chooseYourPlan: "Choose your plan", perMonth: "/ month",
    subscribeCard: "Pay by card (Stripe)", subscribeWave: "Pay with Wave", subscribeOrange: "Pay with Orange Money",
    mostPopular: "Most popular",
    cancel: "Cancel subscription",
    transactions: "Payment history",
    bannerTrial: "You are on free trial",
    bannerGrace: "Grace period — payment required soon",
    bannerReadOnly: "Subscription expired — read-only",
    bannerCancelled: "Subscription cancelled",
    renew: "Renew now",
    paymentProcessing: "Payment being validated…",
    paymentSuccess: "Payment confirmed!",
    paymentFailed: "Payment failed or was cancelled.",
    currentlyOn: "Current plan",
    upgrade: "Upgrade to",
    simulatedNote: "Simulated mobile money payment — real integration will be enabled in production.",
  },
};

export const locales = { fr, en };
